<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Form Add Product Requisition" subTitle="Forms" />

    <AddProductRequisition />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import AddProductRequisition from "@/components/Pages/Management/Requisition/AddProduct.vue";

export default defineComponent({
  name: "AddProductRequisitionPage",
  components: {
    PageTitle,
    AddProductRequisition,
  },
});
</script>
